import React, { MouseEventHandler } from 'react';

import { Check, CopyIcon } from 'lucide-react';

import { Badge } from '@/components/shadcn/ui/badge';

const BuildDetailsCopyBadge: React.FC<{ value: string | number; maskValue?: (value: string | number) => string }> = ({
  value,
  maskValue,
}) => {
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  const handleCopy: MouseEventHandler = (e) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(String(value));
    setIsCopied(true);
  };

  return (
    <Badge className="cursor-pointer" onClick={handleCopy}>
      {isCopied ? <Check className="mr-1 size-3" color="green" /> : <CopyIcon className="mr-1 size-3" />}
      {maskValue ? maskValue(value) : value}
    </Badge>
  );
};

export default BuildDetailsCopyBadge;
